<template>
  <div>
    <b-tabs>
      <b-tab title="Search Engine Configuration">
        <SearchEngineConfigurationComponent
          :futureRisksEdit="futureRisksEdit"
          :categoriesIndex="tabIndex"
          :futureRiskTab="true"
          :searchPage="searchPage"
        />
      </b-tab>
      <b-tab title="Search Text">
        <SearchTextComponent
          :futureRisksEdit="futureRisksEdit"
          :categoriesIndex="tabIndex"
          :futureRiskTab="true"
          :searchPage="searchPage"
        />
      </b-tab>
      <b-tab title="Keywords">
        <KeywordComponent
          :futureRisksEdit="futureRisksEdit"
          :categoriesIndex="tabIndex"
          :futureRiskTab="true"
          :searchPage="searchPage"
          :priConfigrationKeywordsData="priConfigrationKeywordsData"
          :priConfigrationExcludeKeywordsData="priConfigrationExcludeKeywordsData"
        />
      </b-tab>
      <b-tab title="Stopwords">
        <StopwordsComponent
          :futureRisksEdit="futureRisksEdit"
          :categoriesIndex="tabIndex"
          :futureRiskTab="true"
          :searchPage="searchPage"
          :priConfigrationStopWordsData="priConfigrationStopWordsData"
        />
      </b-tab>
      <b-tab title="Natural Language Processing">
        <NaturalLanguageProcessingComponent
          :futureRisksEdit="futureRisksEdit"
          :categoriesIndex="tabIndex"
          :futureRiskTab="true"
          :searchPage="searchPage"
        />
      </b-tab>
      <b-tab title="Scoring">
        <ScoringComponent
          :futureRisksEdit="futureRisksEdit"
          :categoriesIndex="tabIndex"
          :futureRiskTab="true"
          :searchPage="searchPage"
        />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import KeywordComponent from "./negativeMediaComponent/keywordsComponent.vue";
import StopwordsComponent from "./negativeMediaComponent/stopwordsComponent.vue";
import NaturalLanguageProcessingComponent from "./negativeMediaComponent/naturalLanguageProcessingComponent.vue";
import SearchEngineConfigurationComponent from "./negativeMediaComponent/searchEngineConfigurationComponent.vue";
import ScoringComponent from "./negativeMediaComponent/scoringComponent.vue";
import SearchTextComponent from "./negativeMediaComponent/searchTextComponent.vue";
export default {
  name: "FutureRiskComponent",
  components: {
    KeywordComponent,
    StopwordsComponent,
    NaturalLanguageProcessingComponent,
    SearchEngineConfigurationComponent,
    ScoringComponent,
    SearchTextComponent
  },
  data() {
    return {
      selectedLanguage: "lang_en"
    };
  },
  methods: {},
  props: {
    tabIndex: Number,
    futureRisksEdit: Boolean,
    searchPage: Boolean,
    priConfigrationKeywordsData: Array,
    priConfigrationExcludeKeywordsData: Array,
    priConfigrationStopWordsData: Array
  }
};
</script>
